module.exports = __webpack_public_path__ + "static/img/yantai-index.753ca086.jpg";